/* eslint-disable max-len */

export const BellWithNotification = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 125 146" {...props}>
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M58.649 104.967c29.321 16.774 50.693 34.434 47.755 39.455-2.938 5.021-29.062-4.479-58.384-21.254C18.728 106.422-2.644 88.762.265 83.741c2.938-5.02 29.062 4.479 58.384 21.254v-.028Z"
        clipRule="evenodd"
      />
      <path
        fill="url(#b)"
        fillRule="evenodd"
        d="M106.948 22.145c5.674 3.253 7.633 10.442 4.349 16.062-3.284 5.62-10.542 7.56-16.216 4.308-5.674-3.253-7.633-10.442-4.35-16.062 3.284-5.62 10.543-7.56 16.217-4.308Z"
        clipRule="evenodd"
      />
      <path
        fill="url(#c)"
        d="M49.431 119.502c4.617 1.622 10.315-2.573 12.727-9.369 2.41-6.797.623-13.621-3.994-15.243-4.617-1.622-10.315 2.573-12.727 9.369-2.41 6.797-.623 13.621 3.994 15.243Z"
      />
      <path
        fill="url(#d)"
        fillRule="evenodd"
        d="M106.061 141.164c-1.037-2.911-3.053-10.899.576-21.768 3.341-9.984 10.024-27.102 13.422-35.718a41.03 41.03 0 0 0 2.103-5.277c5.876-18.487-1.728-39.113-19.327-49.184-17.598-10.07-39.46-6.248-52.652 7.988-1.267 1.426-2.477 2.881-3.571 4.45-5.847 7.247-17.484 21.511-24.54 29.385C14.41 79.57 6.374 81.852 3.35 82.395c8.209-.514 30.646 8.443 55.33 22.566 24.684 14.121 43.752 28.87 47.41 36.174l-.029.029Z"
        clipRule="evenodd"
      />
      <path
        stroke="url(#e)"
        strokeOpacity=".4"
        d="M104.706 138.128c-.987-1.257-2.247-2.629-3.745-4.096-2.707-2.648-6.22-5.631-10.386-8.821-8.33-6.383-19.288-13.612-31.646-20.682-12.357-7.07-24.158-12.85-33.903-16.8-4.873-1.975-9.238-3.496-12.907-4.492-2.053-.556-3.9-.952-5.504-1.169 3.966-1.29 10.009-4.216 15.83-10.697 7.067-7.885 18.711-22.16 24.557-29.404l.011-.014.01-.014c1.078-1.545 2.272-2.983 3.532-4.4 13.037-14.066 34.641-17.842 52.031-7.891 17.391 9.952 24.905 30.334 19.099 48.602a40.516 40.516 0 0 1-2.077 5.213l-.007.017-.007.016c-3.398 8.613-10.085 25.743-13.431 35.743-2.746 8.224-2.301 14.831-1.457 18.889Z"
      />
      <g filter="url(#f)">
        <path
          fill="url(#g)"
          fillRule="evenodd"
          d="M53.509 59.211c12.394 0 22.529-10.055 22.529-22.41 0-12.354-10.135-22.383-22.529-22.383-12.393 0-22.529 10.055-22.529 22.41s10.109 22.41 22.529 22.41v-.027Z"
          clipRule="evenodd"
        />
        <mask id="h" width="15" height="22" x="46" y="24" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }}>
          <path fill="#fff" d="M60.082 24.691H46.94v20.543h13.142V24.69Z" />
        </mask>
        <g mask="url(#h)">
          <path
            fill="#fff"
            d="M59.585 43.002v2.232H48.58v-2.232h4.205V30.649c0-.438.014-.885.043-1.342l-3.239 2.67c-.14.11-.285.183-.434.22a1.014 1.014 0 0 1-.407 0 1.329 1.329 0 0 1-.336-.123.962.962 0 0 1-.225-.206l-.939-1.287 6.084-5.108h2.453v17.529h3.8Z"
            opacity=".76"
          />
        </g>
      </g>
      <defs>
        <linearGradient id="a" x1="34.5" x2="82.251" y1="141.482" y2="91.493" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6E6E8F" />
          <stop offset="1" stopColor="#484856" />
        </linearGradient>
        <linearGradient id="b" x1="101.589" x2="100.284" y1="41.466" y2="20.613" gradientUnits="userSpaceOnUse">
          <stop stopColor="#A9A9B9" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient id="c" x1="58.164" x2="49.509" y1="94.89" y2="119.528" gradientUnits="userSpaceOnUse">
          <stop stopColor="#73738F" />
          <stop offset="1" stopColor="#21212D" />
        </linearGradient>
        <linearGradient id="d" x1="63.735" x2="63.735" y1="141.164" y2="23.564" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BEBECC" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient id="e" x1="31.924" x2="98.436" y1="-24.181" y2="136.205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" stopOpacity=".23" />
          <stop offset=".743" stopColor="#FCFCFC" stopOpacity=".08" />
        </linearGradient>
        <linearGradient id="g" x1="30.98" x2="76.038" y1="36.828" y2="36.828" gradientUnits="userSpaceOnUse">
          <stop stopColor="#DD2476" />
          <stop offset="1" stopColor="#FF512F" />
        </linearGradient>
        <filter
          id="f"
          width="93.058"
          height="92.819"
          x="16.98"
          y=".418"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dx="10" dy="10" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.160784 0 0 0 0 0.192157 0 0 0 0.24 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1338_2795" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1338_2795" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
